export enum TaxType {
  UNDEFINED = 'undefined',
  TAXABLE = 'taxable',
  EXEMPT = 'exempt',
  NON_TAXABLE = 'non_taxable',
  EXPORT = 'export',
}

export const taxesTypes = ['taxable', 'exempt', 'non_taxable', 'export'];
